"use client";

import { SupportContact } from "@/features/service-information/SupportContact";
import { useSyncExternalStore } from "react";
import { X } from "@app-foundation/icons/lucide";
import styles from "./BetaAnnouncement.module.css";

const storageKey = "mira-beta-v1-announcement-dismissed";
const changeEvent = "mira-beta-announcement-change";
let dismissedInMemory = false;

function subscribe(onChange: () => void) {
  window.addEventListener(changeEvent, onChange);
  return () => window.removeEventListener(changeEvent, onChange);
}

function getDismissed() {
  try {
    return dismissedInMemory || sessionStorage.getItem(storageKey) === "1";
  } catch {
    return dismissedInMemory;
  }
}

export function BetaAnnouncement() {
  const dismissed = useSyncExternalStore(subscribe, getDismissed, () => false);
  if (dismissed) return null;

  function dismiss() {
    dismissedInMemory = true;
    try {
      sessionStorage.setItem(storageKey, "1");
    } catch {
      // Closing remains available when browser storage is unavailable.
    }
    window.dispatchEvent(new Event(changeEvent));
  }

  return <aside className={styles.banner} aria-label="V1.0 公测公告">
    <div className={styles.message}>
      V1.0 公测中，欢迎反馈使用体验与问题。请依法合规使用，并确保已取得相关内容的必要授权；如有疑问或发现异常，请联系<SupportContact label="官方客服" className={styles.support} side="bottom" />。
    </div>
    <button type="button" className={styles.close} aria-label="关闭公测公告" onClick={dismiss}>
      <X size={14} aria-hidden="true" />
    </button>
  </aside>;
}
